export var ADD_NON_CLOUD_FILE = "FILE_TREE.ADD_NON_CLOUD_FILE";
export var DELETE_NON_CLOUD_FILE = "FILE_TREE.DELETE_NON_CLOUD_FILE";
export var CLEANUP_NON_CLOUD_FILES = "FILE_TREE.CLEANUP_NON_CLOUD_FILES";
// AKA in-memory files (ex. from render)
